// Triggers a browser save for a blob response, e.g. from an axios call with
// responseType: 'blob'. Reads the filename from Content-Disposition when present.
export function saveBlobResponse(response, fallbackName) {
  const disposition = response.headers?.['content-disposition'];
  const match = disposition && /filename="?([^"]+)"?/.exec(disposition);
  const filename = match?.[1] || fallbackName;

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
